<template>
    <AppNavigation>
        <mdb-container fluid>
            <h1 class="h1-responsive">Change Password</h1>
            <hr>
            <mdb-row>
                <mdb-col col="4">
                    <mdb-input type="password" label="Current Password" v-model="current" />
                </mdb-col>
            </mdb-row>
            <mdb-row>
                <mdb-col col="4">
                    <mdb-input type="password" label="New Password" v-model="password" />
                </mdb-col>
            </mdb-row>
            <mdb-row>
                <mdb-col col="4">
                    <mdb-input type="password" label="Confirm Password" v-model="confirmation" />
                </mdb-col>
            </mdb-row>
            <mdb-row>
                <mdb-btn v-if="!loading" color="primary" @click="changePassword" size="small">Change Password</mdb-btn>
                <mdb-spinner small v-if="loading" color="blue" />
            </mdb-row>
        </mdb-container>
    </AppNavigation>
</template>

<script>
// @ is an alias to /src
import {mdbContainer, mdbRow, mdbCol, mdbInput, mdbBtn, mdbSpinner } from 'mdbvue';
import AppNavigation from '../components/AppNavigation';
import {ajax} from '../js/ajax';
import {validateRequired} from '../js/validation';

export default {
  name: 'change_password',
  components: {
    mdbContainer, mdbBtn, 
    AppNavigation,
    mdbRow, mdbCol, mdbInput, mdbSpinner
  },
  data: ()=>({
      current: "",
      password: "",
      confirmation: "",
      loading:false,
  }),
  methods: {
      changePassword(){
            if(!validateRequired(this.current)){
                this.$notify.error({message: 'Please Enter Current Password', position:'top right', timeOut: 5000});
                return false;
            }
            if(!validateRequired(this.password)){
                this.$notify.error({message: 'Please Enter New Password', position:'top right', timeOut: 5000});
                return false;
            }
            if(!validateRequired(this.confirmation)){
                this.$notify.error({message: 'Please Enter Confirm Password', position:'top right', timeOut: 5000});
                return false;
            }
            if(this.confirmation!=this.password){
                this.$notify.error({message: 'Password not match', position:'top right', timeOut: 5000});
                return false;
            }
            this.loading=true;
            ajax({
                url: "admin/admin_change_password",
                data: {password: this.password, current_password: this.current, password_confirmation: this.confirmation},
                complete: ()=>this.loading=false,
                success: ()=>{
                    this.current="";
                    this.password="";
                    this.confirmation="";
                    this.$notify.success({message: "Password Updated Successfully", position: 'top right', timeOut: 5000});
                }
            }, this)
      }
  },
  mounted: function(){
  }
}
</script>
